<template>
    <div id="feedback360">
        <div class="feedback360_content" v-if="isLoaded">
            <div class="title_container">
                <h1 class="title">{{$t("views.Feedback360.title")}}</h1>
                <span class="desc_title">{{$t("views.Feedback360.descTitle")}}</span>
            </div>
            <div class="select_podium">
                <select v-for="(positionSelect, index) in players" class="selectPodium" :key="positionSelect.position" @change="changePosition($event)">
                    <option  disabled selected value="label">{{$t("views.Feedback360.selectPodium[0]")}} {{index + 1}} {{$t("views.Feedback360.selectPodium[1]")}}</option>
                    <option :value="player.id"  v-for="player in players" :key="player.position">{{player.name}}</option>
                </select>
            </div>
            <div class="clear_form" @click="clearForm()">
                <span>{{$t("views.Feedback360.clearForm")}}</span>
            </div>
            <button class="default_button" ref="send_evaluation" @click="sendEvaluation()" disabled 
            
            :style="{
                'background-color': buttonStyle.backgroundColor,
                'box-shadow': buttonStyle.boxShadow
            }">            
            
                <span>{{$t("views.Feedback360.evaluate")}}</span>
                <!-- <div class="arrow-right"></div> -->
            </button>
        </div>
        <loader-request v-if="!isLoaded"></loader-request>
        <Alert v-if="alert.show"
				:imageSrc="alert.imageSrc"
				:title="alert.title"
				:subtitle="alert.subtitle"></Alert>
    </div>
</template>

<script>
import decodeApi from '../api/decode'
import LoaderRequest from '../components/Loaders/LoaderRequest'
import Alert from '../components/Alerts/AlertGlobal';
import Bus from '@/main.js'
import {addAlpha} from "../helpers/custom"

export default {
    components: {
        'loader-request': LoaderRequest, Alert
    },

    data(){
        return{
            players: [],
            isLoaded: false,
            warningCount: 0,
            selectedOptionsValues: [],
            rankingOrder: ["first", "second", "third", "fourth"],
            group: '',
            colors:{},
            buttonStyle: {},
            alert: {
                imageSrc: "warning",
                title: this.$t("views.Feedback360.alertInfo.title"),
                subtitle: this.$t("views.Feedback360.alertInfo.subtitle")
            }            
        }
    },

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        Bus.$on('closeAlertGlobal', this.closeAlertGlobal)
        const alert = this.alert
        this.getGroup()
        let warningCount = 0
        function warningEvent(alert){
            if(warningCount < 2){
                warningCount ++
                Bus.$emit("openAlertGlobal", alert)
            }
        }
        document.onmouseleave = function() { warningEvent(alert) };
        window.addEventListener("blur", function(){ warningEvent(alert)} )      
    },
        
    methods: {
        changePosition(){
            const selects = document.querySelectorAll('.selectPodium')
            selects.forEach((select, index) => {
                if(!this.selectedOptionsValues.some(optionValue => optionValue == select.options[select.selectedIndex].value) && select.options[select.selectedIndex].value != 'label')
                    this.selectedOptionsValues[index] = select.options[select.selectedIndex].value
            });
            selects.forEach(select => {
                for(var i = 1; i <= this.players.length; i++){                  
                    select.options[i].removeAttribute('disabled')
                    if(this.selectedOptionsValues.some(optionValue => optionValue == select.options[i].value)) select.options[i].setAttribute('disabled', true)    
                }
            });

            if(this.selectedOptionsValues.every(selectedOptionValue => selectedOptionValue != null) 
                && this.selectedOptionsValues.length == this.players.length) this.$refs.send_evaluation.removeAttribute('disabled') 
                this.defineStyle()      

        },
        clearForm(){
            this.$refs.send_evaluation.setAttribute('disabled', true)     
            const selects = document.querySelectorAll('.selectPodium')
            selects.forEach((select, index) => {
                    selects[index].value = 'label' 
                for(var i = 1; i <= this.players.length; i++){                  
                    select.options[i].removeAttribute('disabled')
                }
            });
            this.selectedOptionsValues = []
            this.defineStyle()
        },
        async getGroup(){
            const { userId, groupId, sessionId } = await this.$store.getters.getSimple(["userId", "groupId", "sessionId"])
            
            console.log({ userId, groupId, sessionId })
            if (!groupId) {
                const getGroup = await decodeApi.get(`/groups/?sessionId=${sessionId}&userId=${userId}`)
                const groupIdBySession = getGroup.data.groups[0].id

                localStorage.setItem('groupId', groupIdBySession)
                this.groupId = groupIdBySession
            } else {
                this.groupId = groupId
            }
            this.userId = userId
            
            const group = await decodeApi.get(`/groups/${this.groupId}`)
            this.isLoaded = true
            this.players = group.data.group.players  
            this.group = group.data.group  
            this.players.forEach((player, index) => { if(player.id == this.userId) this.players.splice(index, 1)})
        },  
        async sendEvaluation(){
            this.isLoaded = false
            let ranking = []
            for (const index in this.selectedOptionsValues) {
                ranking.push({
                    evaluatedId: this.selectedOptionsValues[index],
                    order: this.rankingOrder[index]
                })
            }
            const body = {
                appraiserId: this.userId,
                ranking: ranking,
                groupId: this.groupId,
                sessionId: this.group.sessionId
            }
            try {
                let evaluationReq = await decodeApi.post('/evaluations', body)
                this.isLoaded = true
                // console.log("evaluationReq: ", evaluationReq.data)
                this.$router.push('/middleware-report')
            // this.$router.push('/feedback-alert')
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.error("Error trying to send evaluation: ", error)
                // console.log("More details: ", error.response.data.response)
            }
        },
		closeAlertGlobal(){
			this.alert.show = false
		},
        defineStyle(){
            this.buttonStyle =  {
                boxShadow: this.selectedOptionsValues.length > 0 ? '0px 5px 0px 0px ' + addAlpha(this.colors.secondary, 0.5) : '0px 5px 0px 0px' + addAlpha('#798799', 0.5),
                backgroundColor: this.selectedOptionsValues.length != 0 ? this.colors.secondary : '#798799'
            }
        },        
    },
    destroyed(){
        Bus.$off('openAlertGlobal')
        Bus.$off('closeAlertGlobal')
    },
}
</script>


<style lang="scss" scoped>
    #feedback360{
        height: calc(100vh - 65px);
        background: #282d30;

        .feedback360_content{
            height: 100%;
        }

        .title_container{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 75px 32px 32px;
            color: #ffffff;

            .title{

                font-size: 30px;
                text-align: center;
                text-transform: uppercase;
                line-height: 30px;

            }
            .desc_title{
                font-size: 17px;
                margin-top: 15px;
            }
        }

        .select_podium{
            display: flex;
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;

            select{
                // color: #fff;
                margin: 5px 10px;
                background-color: #000;
                color: #fff;
                padding: 5px 15px;
                width: 70%;
                border-radius: 30px;

                option{
                    position: absolute;

                }
            }
        }
        .clear_form{
            padding: 12px 0px;
            color: #fff;
            text-transform: uppercase;
            letter-spacing: 3px;
            font-size: 12px;
            max-width: 180px;
            margin: 32px auto;
            border: 1px solid #fff;
            text-align: center;
            border-radius: 45px;

            &:hover{
                cursor: pointer;
            }
        }
        .default_button{
            display: flex;
            font-weight: 700;
            align-items: center;
            text-align: center;
            font-weight: 700;
            text-decoration: none;
            width: 50%;
            max-width: 620px;
            bottom: 0;
            transition: background .5s, color .5s, opacity .7s;
            border: none;
            border-radius: 40px;
            padding: 14px;
            margin: 0 auto;
            justify-content: center;
            // box-shadow: #9fa2a7 ;
            color: #fff;
            // position: relative;
            // top: 40%;


            &:disabled{
                background: #ccc;
                border: none;
                opacity: .5;
            }


            span{
                font-size: 15px;
                letter-spacing: 2px;
                text-transform: uppercase;
            }

            .arrow-right{
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #000;
            }
        }

            .default_button.disabled{
                opacity: .2;
                // background: #2f353a94;
                color: #fff;
            }
    }

    @media only screen and (min-width : 749px){

        #feedback360{
            height: 90%;

            .default_button{

                // position: absolute;
                // height: 75px;
            }
        }
    }
</style>
